<template>
	<div class="row">
		<div class="mr-auto ml-auto col-lg-10">
			<button @click="showModalDiscount = true" class="btn btn-primary">
				{{ 'Add discount' | translate }}
			</button>
			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>ID</th>
						<th>
							{{ 'Master Franchise' | translate }} /
							{{ 'Franchise' | translate }}
						</th>
						<th>{{ 'Start' | translate }}</th>
						<th>{{ 'End' | translate }}</th>
						<th>{{ 'Discount' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr v-for="setting in listSettings" :key="setting.id">
						<td>{{ setting.id }}</td>
						<td>
							<router-link
								:to="{
									name: 'Dashboard Profile',
									params: { id: setting.franchise },
								}"
								>{{ setting.franchise }}</router-link
							>
						</td>
						<td>{{ setting.start }}</td>
						<td>{{ setting.end }}</td>
						<td>{{ setting.value }}%</td>
						<td>
							<a
								href="#"
								@click.prevent="openModal(setting.id, 'delete')"
								class="text-red"
								>{{ 'Delete' | translate }}</a
							>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<ModalDiscount
			@close="showModalDiscount = false"
			:show="showModalDiscount"
		></ModalDiscount>
		<ModalDelete
			@deleteUser="deleteDiscount"
			@close="showModalDelete = false"
			:show="showModalDelete"
		></ModalDelete>
	</div>
</template>

<script>
import ModalDiscount from './Modal/Discount.vue'
import ModalDelete from './Modal/Delete.vue'

export default {
	name: 'settings-list',
	data() {
		return {
			listSettings: [],
			showModalDelete: false,
			showModalDiscount: false,
		}
	},
	components: {
		ModalDiscount,
		ModalDelete,
	},
	methods: {
		openModal(id, type) {
			let profileArr = []
			profileArr.push(id)
			this.$store.commit('changeModalId', profileArr)
			this.showModalDelete = true
		},
		deleteDiscount() {},
		updateList() {
			this.axios({
				method: 'get',
				url: 'users/discount',
			}).then(response => {
				this.listSettings = response.data
			})
		},
	},
	created() {
		this.updateList()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
